import { useAuthStore } from '../stores/authStore';
import type { OrganizationVariant } from '../types/organization';

/**
 * Retourne le variant de l'organisation courante.
 *
 * Source de vérité : `useAuthStore().organization.variant`, peuplé au login
 * par `/auth/me` qui mirrore `customer-service.companies.variant` via Kafka.
 *
 * Fallback : 'standard' si l'utilisateur n'a pas encore d'organisation
 * (onboarding) ou si le backend ne renvoie pas le champ (legacy).
 */
export function useCompanyVariant(): OrganizationVariant {
  const organization = useAuthStore((s) => s.organization);
  const raw = organization?.variant;
  if (raw === 'cooperative') return 'cooperative';
  return 'standard';
}
